import { createTheme } from '@mui/material/styles';
import { makeTypography } from './typography';
import { makeOverrides } from './overrides';
import { palette } from './palette';
// import '../../assets/stylesheet.css';

export const uplift = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1440,
      xl: 1920,
    }
  },
  typography: {
    fontFamily: "'Inter', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    fontSize: 16,
    htmlFontSize: 16,
  },
  palette,
  components: makeOverrides(),
});

uplift.typography = makeTypography(uplift);
